// extracted by mini-css-extract-plugin
export default {"groupContact":"contact_groupContact__ALuPN","actions":"contact_actions__id+ZA","data":"contact_data__SRRvv"};